import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchDispath } from '../../functions/fetch'
import { makeStyles } from '@mui/styles';
import * as actions from '../../reducers/form';
import { getWork, updWorkPrice } from '../../api/work'
// import { getMaterialsList, updateMaterialPrice } from '../../api/material'
import {
  Table, TableBody, TableCell, TableHead, Button, Checkbox, TableSortLabel,
  TableRow, TableContainer, InputBase, Typography, IconButton,
  Grid
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Clear'
import IncreasePriceDialog from './workPrice/IncreasePriceDialog'
const formName = 'materialPrice'
const directionSortConst = {
  ASC: 'asc',
  DESC: 'desc',
};

export default function WorkPrice({ match, history }) {
  const dispatch = useDispatch()
  const projectId = match.params.idProject
  useEffect(() => {
    dispatch(actions.formInitialize({ byId: {}, allIds: [], allIdsFirst: [], sortBy: 'pos', sortDirection: directionSortConst.DESC, selectedId: [] }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchDispath({
      param: { id: projectId, },
      progress: true,
      request: getWork,
    })).then(res => {
      let byId = {}
      const allIds = res.get.sort((a, b) => (Number(a.number) > Number(b.number) ? 1 : -1)).map((v, i) => {
        const rowId = 'b' + v.id + '_' + i
        byId[rowId] = {
          id: v.id,
          pos: v.number,
          count: v.count,
          name: v.name,
          su: v.storageUnit,
          priceNew: Number(v.price) || 0,
          priceOld: Number(v.price) || 0,
          selected: false
        }
        return rowId
      })
      const newArr = stableSort(allIds, byId, 'pos', directionSortConst.DESC)
      dispatch(actions.formChangeAsObj({ byId, allIds: newArr, allIdsFirst: newArr }, { name: formName }))
    })
  }, [dispatch, projectId])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { byId, allIds = [] } = form.values
  return <div className='App-paper'>
    <Typography variant='h6'>Изменение цен на работу</Typography>
    <Grid
      container
      direction="row"
      justifyContent='flex-start'
      alignItems="center"
      spacing={2}
    >
      <Grid item><IncreasePriceDialog formName={formName} projectId={projectId} /></Grid>
      <Grid item xs={6}><FindText /></Grid>
    </Grid>
    <TableContainer style={{ height: '83vh' }}>
      <Table size='small' stickyHeader >
        <TableHeadCustom formName={formName} />
        <TableBody>
          {allIds.map(key => {
            const obj = byId[key]
            return <TableRowCustom key={key} obj={obj} id={key} projectId={projectId} />
          })}
        </TableBody>
      </Table>
    </TableContainer>
    <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
  </div>
}
function TableHeadCustom({ formName }) {
  const form = useSelector(state => state.form[formName] || state.form.default)
  const dispatch = useDispatch()
  const { allIds = [], byId = {}, selectedId = [], sortBy = 'name', sortDirection = 'asc' } = form.values
  const handleChangeAll = () => {
    const all = allIds.length === selectedId.length
    if (all) {
      dispatch(actions.formChangeAsObj({ selectedId: [] }, { name: formName }))
      allIds.forEach(key => {
        dispatch(actions.formObjChangeObj({ selected: false }, { field: 'byId', id: key, name: formName }))
      });
    }
    else {
      dispatch(actions.formChangeAsObj({ selectedId: allIds }, { name: formName }))
      allIds.forEach(key => {
        dispatch(actions.formObjChangeObj({ selected: true }, { field: 'byId', id: key, name: formName }))
      });
    }
  }
  const handleRequestSort = (sortByNew) => {
    let sortDirectionNew = directionSortConst.DESC;
    if (sortBy === sortByNew && sortDirection === directionSortConst.DESC) {
      sortDirectionNew = directionSortConst.ASC;
    }
    const newArr = stableSort(allIds, byId, sortByNew, sortDirectionNew)
    dispatch(actions.formChangeAsObj({ sortBy: sortByNew, sortDirection: sortDirectionNew, allIds: newArr }, { name: formName }))
  };
  return <TableHead>
    <TableRow>
      <TableCell padding="checkbox">
        <Checkbox
          checked={selectedId.length !== 0}
          onClick={handleChangeAll}
          indeterminate={allIds.length !== selectedId.length && selectedId.length !== 0}
        />
      </TableCell>
      {
        [
          { value: 'pos', label: 'Позиция', style: { minWidth: '10%' } },
          { value: 'name', label: 'Наименование', style: { minWidth: '10%' } },
          { value: 'su', label: 'Единица измерения', style: { minWidth: '10%' } },
          { value: 'count', label: 'Количество', style: { minWidth: '10%' } },
          { value: 'priceOld', label: 'Старая цена', style: { width: '15%' } },
        ].map((v, i) => {
          return <TableCell sortDirection={sortBy === v.value ? sortDirection : false} style={v.style}     >
            <TableSortLabel
              active={sortBy === v.value}
              direction={sortDirection}
              onClick={() => handleRequestSort(v.value)}
            >
              {v.label}
            </TableSortLabel>
          </TableCell>
        })
      }
      <TableCell style={{ width: '15%' }}>Новая цена</TableCell>
      <TableCell style={{ minWidth: '15%' }}>Сумма</TableCell>
    </TableRow>
  </TableHead>
}
const useStyles = makeStyles(theme => ({
  row: {
    color: '#000000',
    '&$selected': {
      color: '#aaaaaa'
    },
    "&:hover": { backgroundColor: theme.palette.action.hover }
  },
  selected: {},
}));
function TableRowCustom({ obj, id, projectId }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const handleChangeOne = () => {
    dispatch(actions.formObjChangeObj({ selected: !obj.selected }, { field: 'byId', id: id, name: formName }))
    if (obj.selected) {
      dispatch(actions.formArrayDelete(id, { field: 'selectedId', name: formName }));
    }
    else {
      dispatch(actions.formArrayAdd(id, { field: 'selectedId', name: formName }))
    }
  }
  return <TableRow classes={{ root: classes.row, selected: classes.selected, }} selected={obj.selected}>
    <TableCell padding="checkbox">
      <Checkbox
        checked={obj.selected}
        onClick={handleChangeOne}
      />
    </TableCell>
    {['pos', 'name', 'su', 'count', 'priceOld'].map(v => {
      return <TableCell key={v}>{obj[v]}</TableCell>
    })}
    <EditPrice value={obj.priceNew} priceOld={obj.priceOld} id={obj.id} row={id} projectId={projectId} />
    <TableCell>{(Math.round(obj.count * obj.priceNew * 100) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}</TableCell>
  </TableRow>
}
const useStylesField = makeStyles((theme) => ({
  searchField: {
    backgroundColor: '#f8f9fa', // Легкий серый фон по умолчанию
    borderBottom: '1px solid #e0e0e0', // Едва заметная рамка
    // padding: '4px 12px',        // Отступы внутри поля (справа меньше из-за кнопки)
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: '#b0b0b0',
      backgroundColor: '#f1f3f4',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      borderColor: '#1976d2', // Фирменный синий цвет (или цвет вашего бренда)
    },
  },
}));
const FindText = () => {
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { byId = {}, allIdsFirst = [] } = form.values
  const [find, setFind] = useState('')
  const dispatch = useDispatch()
  const classes = useStylesField();
  const textEdit = value => {
    setFind(value)
    const newArr = allIdsFirst.filter(item => {
      const name = byId[item]?.name
      return name.toLowerCase().includes(value.toLowerCase())
    })
    dispatch(actions.formChangeAsObj({ allIds: newArr }, { name: formName }))
  }
  return (
    <InputBase
      className={classes.searchField}
      onChange={(e) => textEdit(e.target.value)}
      placeholder='Найти'
      value={find}
      fullWidth
      endAdornment={<IconButton aria-label="Delete" onClick={() => textEdit('')} size="small">
        <DeleteIcon />
      </IconButton>}
    />
  );
}
const useStylesEdit = makeStyles((theme) => ({
  inputNumber: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
}));
function EditPrice({ value, priceOld, id, row, projectId }) {
  const dispatch = useDispatch()
  const classes = useStylesEdit()
  const [edit, setEdit] = useState(value)
  const handleChange = (e) => {
    dispatch(actions.formObjChangeObj({ priceNew: e.target.value }, { field: 'byId', id: row, name: formName }))
  }
  const handleBlur = () => {
    if (edit === value) return;
    dispatch(fetchDispath({
      param: { id: projectId },
      body: {
        arr: [{ id: id, price: value }]
      },
      progress: true,
      request: updWorkPrice,
    }))
  }
  return <TableCell style={{ backgroundColor: (Number(value) === Number(priceOld)) ? '#0000000a' : 'rgba(184, 241, 184, 1)' }}>
    <InputBase
      value={value}
      className={classes.inputNumber}
      type='number'
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={(e) => { setEdit(value); e.target.select(); }}
      fullWidth
    />
  </TableCell>
}


function stableSort(array, objs, orderBy, order) {
  const stabilizedThis = array.map(key => ([key, String(objs[key][orderBy])]));
  const ord = order === directionSortConst.DESC ? 1 : -1
  stabilizedThis.sort((a, b) => {
    return ord * a[1].localeCompare(b[1], undefined, { numeric: true, sensitivity: 'base' })
    // return ord * desc(a[1], b[1]);
  });
  return stabilizedThis.map(el => el[0]);
}